
export class StoryComponentText {
    storyNameErrorMessage: string = 'Story Name required.';
    storyHeadlineErrorMessage: string = 'Headline required.';
    storyCompanyNameErrorMessage: string = 'Company Name required.';
    storyBodyTextErrorMessage: string = 'Body text required.';
    storyBodyTextLengthErrorMessage: string = 'Formatted character limit exceeded.';
    publishDisclaimerMessage: string = 'I agree that upon clicking "Agree and Publish",'
        + ' my story will be published to the Agility PR Solutions Newsroom;'
        + ' and I have approved the content and format.';
    newroomGuideline: string = 'Newsroom Editorial Guidelines';
    contactsError = 'At least one contact must contain information for "Name", "Phone", and "Email".';
    contactsEmailError = 'Contact emails must be valid.';
    saveFailedHeading = 'Save Failed';
    saveFailedMessage = 'Story could not be saved';
    publishFailedHeading = 'Publish Failed';
    publishFailedMessage = 'Story "[[name]]" could not be published';
    contactValidationMessage = 'All contacts must have a Name, and at least one contact must include either a Phone or Email.';
}
